import React, { useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { SellerIDContext } from '../../App';
import { getCurrentDomain, getLoaderSellerIDHint } from '../../utils/domainResolver';
import { resolveSellerLoader } from '../../config/sellerLoaders';
import LazyLoader from './LazyLoader';

const SellerLoader = ({ embedded = false, sellerID: sellerIDProp }) => {
  const sellerFromContext = useContext(SellerIDContext);
  const location = useLocation();

  const html = useMemo(() => {
    const config = resolveSellerLoader({
      domain: getCurrentDomain(),
      sellerID: sellerIDProp || sellerFromContext || getLoaderSellerIDHint(location.pathname),
    });
    return config?.store || null;
  }, [location.pathname, sellerIDProp, sellerFromContext]);

  if (!html) {
    return <LazyLoader embedded={embedded} />;
  }

  const wrapperStyle = embedded
    ? { position: 'relative', width: '100%', minHeight: '100vh', zIndex: 0 }
    : { position: 'fixed', inset: 0, width: '100%', height: '100%', zIndex: 9999 };

  return (
    <div
      style={wrapperStyle}
      dangerouslySetInnerHTML={{ __html: html }}
      role="status"
      aria-live="polite"
      aria-label="Loading store"
    />
  );
};

export default SellerLoader;
